import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .carousel.title {
    background-color: ${baseVariables.color['neutral20']};
    height: ${toRem(28)};
    width: 55%;
    @media ${baseVariables.mediaQuery.xl} {
      width: ${toRem(350)};
      height: ${toRem(32)};
    }
  }
  .carousel-cta {
    display: flex;
    align-items: flex-end;
    margin-right: ${toRem(4)};
    // text-wrap: nowrap;
    background-color: ${baseVariables.color['neutral20']};
    height: ${toRem(16)};
    width: ${toRem(80)};
    margin-top: ${toRem(8)};

    @media ${baseVariables.mediaQuery.xl} {
      width: ${toRem(100)};
      height: ${toRem(16)};
    }
  }
`;

// Styles for SkeletonLoader go here.

export const CarouselSkeletonWrapper = styled.div`
  paddding: 0 ${toRem(24)};
`;

export const CarouselSkeletonText = styled.div`
  margin-bottom: ${toRem(24)};
  max-width: 640px;
  .line {
    background-color: ${baseVariables.color['neutral20']};
    border-radius: ${toRem(3)};
    height: ${toRem(14)};
    margin-bottom: ${toRem(8)};
  }
  .desc-main {
    width: 80%;
    height: ${toRem(28)};
  }
  .desc-sub {
    width: 60%;
    height: ${toRem(18)};
  }
  .sub {
    width: 60%;
  }
`;

export const CarouselSkeletonCards = styled.div`
  display: flex;
  gap: ${toRem(24)};
  width: 100%;
  justify-content: flex-start;
`;

export const CarouselSkeletonCard = styled.div`
  flex: 1 1 0;
  max-width: 480px;
  height: ${toRem(260)};
  border-radius: ${toRem(24)};
  background-color: ${baseVariables.color['neutral20']};
  }
`;

export const CarouselSkeletonDots = styled.div`
  .dots {
    width: ${toRem(16)};
    border-radius: 999px;
    background-color: ${baseVariables.color['neutral20']};
  }

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    gap: ${toRem(8)};
    margin-top: ${toRem(16)};
  }
`;
